import { useLocation } from '@tanstack/react-router'
import { setUTMs } from '@vgw/mar-utm-tracker'
import { useEffect } from 'react'

export const Utms = () => {
  const location = useLocation()

  useEffect(() => {
    // set UTMs on every client navigations
    setUTMs()
  }, [location])

  return null
}
